export default "__VITE_ASSET__Bzaj8Msr__"